import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { Guid } from "@/Common/Models/Guid";

class PrivateBillCostCenter {
    public ID: Guid;
    public Name: string;
    public Code: string;
    public SiteId: string;
    public LookupId: string;

    public static ToComboboxItem(costCenter: PrivateBillCostCenter): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(costCenter.ID, this.GetDisplayName(costCenter), 0);
    }

    public static GetDisplayName(costCenter: PrivateBillCostCenter): string {
        // make sure to handle when LookupID is specified, but the actual lookup is missing.
        if (!costCenter) return null;

        return cacheStore.GetLocalizedValueByLookupId(costCenter.LookupId)
            || costCenter.Name
            || "Undefined cost center.";
    }
}

export { PrivateBillCostCenter };
